<template>
  <div class="container">
    <h1>{{ $t("Layers.title") }}</h1>
    <ul>
      <li v-for="layer in layers" :key="layer.id">
        <router-link :to="{
          name: 'Layer',
          params: { uuid: layer.id }
        }">
          {{ layer.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  data() {
    return {
      layers: []
    }
  },
  apollo: {
    layers: {
      query: gql`query fetchLayers{
        layers(order_by: {sort_order: asc}) {
          id
          name
        }
      }`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Layers.vue